<template>
    <v-container>
        <v-layout row>
            <v-spacer></v-spacer>
            <div class="headline">
                Logging out...<br />
                <div class="error--text">
                    {{ errMsg }}
                </div>

                <v-btn :to="{name: 'Home'}">Back to Home</v-btn>
            </div>
            <v-spacer></v-spacer>
        </v-layout>

    </v-container>
</template>


<script>
import firebase from 'firebase/app'

export default {
  name: 'Logout',
  components: {

  },
  data () {
    return {
        showLogin: true,
        currentUser: null,
        errMsg: ""
      //
    }
  },
  mounted () {
      this.currentUser = firebase.auth().currentUser
      if (this.currentUser && this.currentUser !== null) {
          firebase.auth().signOut()
            .then(() => {
                // Sign-out successful.

                // Clear out the UID
                this.$store.commit('locations/setUID', null)

                // Go home
                this.$router.push({name : "Home"})
            })
            .catch((error) => {
                // An error happened
                console.log("Error logging out: "+error)
                this.errMsg = error
            });
      } else {
          this.errMsg = "You are not logged in."
      }
  }

}
</script>
